module.exports = __webpack_public_path__ + "img/35_41.39f5e963.png";